import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import { getSize, getColor } from '@lib/common';
import styled from '@xstyled/styled-components';
import { BaseQuestionReportComponent } from '../../../bases';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledStatsContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  overflow: hidden;\n\n  /* Mobile: stack vertically */\n  flex-direction: column;\n\n  /* Tablet and up: side by side */\n  @media (min-width: 640px) {\n    flex-direction: row;\n  }\n"])), getColor('fillBgWhite'), getColor('fillIntSubActive'), getSize('radiusSm'));
var StyledStatItem = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n  padding: ", ";\n\n  @media (min-width: 640px) {\n    padding: ", ";\n  }\n"])), getSize('padding12'), getSize('padding12'), getSize('padding16'));
var StyledStatDivider = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  flex-shrink: 0;\n\n  width: 100%;\n  height: 1px;\n\n  @media (min-width: 640px) {\n    width: 1px;\n    height: auto;\n  }\n"])), getColor('fillIntSubActive'));
var StyledStatTexts = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n"])));
var StyledStatLabel = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  line-height: 1rem;\n"])), getSize('typo12'), getColor('textIntSub'));
var StyledStatValue = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.2;\n  display: flex;\n  align-items: center;\n  gap: ", ";\n"])), getSize('typo20'), getColor('contentTitle'), getSize('padding8'));
var StyledStatDescription = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  line-height: 1.4;\n  margin-top: 2px;\n"])), getSize('typo12'), getColor('textIntSub'));
var CIRCLE_SIZE = 48;
var STROKE_WIDTH = 4;
var RADIUS = (CIRCLE_SIZE - STROKE_WIDTH) / 2;
var CIRCUMFERENCE = 2 * Math.PI * RADIUS;

var CircularProgress = function CircularProgress(_ref) {
  var percentage = _ref.percentage;
  var clampedPct = Math.min(100, Math.max(0, percentage));
  var dashOffset = CIRCUMFERENCE * (1 - clampedPct / 100);
  return /*#__PURE__*/_jsxs("svg", {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    style: {
      flexShrink: 0
    },
    children: [/*#__PURE__*/_jsx("circle", {
      cx: CIRCLE_SIZE / 2,
      cy: CIRCLE_SIZE / 2,
      r: RADIUS,
      fill: "none",
      stroke: "#e2e8f0",
      strokeWidth: STROKE_WIDTH
    }), /*#__PURE__*/_jsx("circle", {
      cx: CIRCLE_SIZE / 2,
      cy: CIRCLE_SIZE / 2,
      r: RADIUS,
      fill: "none",
      stroke: "#3b5fe2",
      strokeWidth: STROKE_WIDTH,
      strokeLinecap: "round",
      strokeDasharray: CIRCUMFERENCE,
      strokeDashoffset: dashOffset,
      transform: "rotate(-90 ".concat(CIRCLE_SIZE / 2, " ").concat(CIRCLE_SIZE / 2, ")"),
      style: {
        transition: 'stroke-dashoffset 0.5s ease'
      }
    }), /*#__PURE__*/_jsxs("text", {
      x: CIRCLE_SIZE / 2,
      y: CIRCLE_SIZE / 2 + 1,
      textAnchor: "middle",
      dominantBaseline: "middle",
      fontSize: "10",
      fontWeight: "700",
      fill: "#1e293b",
      children: [clampedPct, "%"]
    })]
  });
};

var EssayStatsPanel = function EssayStatsPanel(_ref2) {
  var achievementRatePercentage = _ref2.achievementRatePercentage,
      participationSubmitted = _ref2.participationSubmitted,
      averagePerformance = _ref2.averagePerformance,
      labels = _ref2.labels;
  return /*#__PURE__*/_jsxs(StyledStatsContainer, {
    children: [/*#__PURE__*/_jsxs(StyledStatItem, {
      children: [/*#__PURE__*/_jsx(CircularProgress, {
        percentage: achievementRatePercentage
      }), /*#__PURE__*/_jsxs(StyledStatTexts, {
        children: [/*#__PURE__*/_jsx(StyledStatLabel, {
          children: labels.achievementRate
        }), /*#__PURE__*/_jsx(StyledStatDescription, {
          children: labels.achievementRateDesc
        })]
      })]
    }), /*#__PURE__*/_jsx(StyledStatDivider, {}), /*#__PURE__*/_jsx(StyledStatItem, {
      children: /*#__PURE__*/_jsxs(StyledStatTexts, {
        children: [/*#__PURE__*/_jsx(StyledStatLabel, {
          children: labels.participation
        }), /*#__PURE__*/_jsxs(StyledStatValue, {
          children: [participationSubmitted, " ", labels.studentsSuffix]
        }), /*#__PURE__*/_jsx(StyledStatDescription, {
          children: labels.participationDesc
        })]
      })
    }), /*#__PURE__*/_jsx(StyledStatDivider, {}), /*#__PURE__*/_jsx(StyledStatItem, {
      children: /*#__PURE__*/_jsxs(StyledStatTexts, {
        children: [/*#__PURE__*/_jsx(StyledStatLabel, {
          children: labels.averagePerformance
        }), /*#__PURE__*/_jsx(StyledStatValue, {
          children: averagePerformance !== -1000 ? "".concat(averagePerformance, " ").concat(labels.ptsSuffix) : '-'
        }), /*#__PURE__*/_jsx(StyledStatDescription, {
          children: labels.averagePerformanceDesc
        })]
      })
    })]
  });
};

export var EssayReportComponent = function EssayReportComponent(_ref3) {
  var states = _ref3.states,
      actions = _ref3.actions;
  var score = states.score,
      totalAttendeeAchievePercentage = states.totalAttendeeAchievePercentage,
      totalAttendeeAchieve = states.totalAttendeeAchieve,
      essayReportLabel = states.essayReportLabel;
  return /*#__PURE__*/_jsx(BaseQuestionReportComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(EssayStatsPanel, {
      achievementRatePercentage: totalAttendeeAchievePercentage,
      participationSubmitted: totalAttendeeAchieve,
      averagePerformance: score,
      labels: essayReportLabel
    })
  });
};